export default {
  AUTH_TOKEN_KEY: 'authToken',
  AUTH_TOKEN_TYPE: 'Bearer',
  AUTH_PATH: 'auth',
  USER_PATH: 'user',
  LOGIN_PATH: 'login',
  LOGOUT_PATH: 'logout'
}
